module.exports = __webpack_public_path__ + "img/mp4.50dc7b64.svg";